import { ANALYTICS } from "@/config/site";

export function initAnalytics() {
  if (ANALYTICS.gaId && !document.getElementById("stj-ga")) {
    const s = document.createElement("script");
    s.id = "stj-ga";
    s.async = true;
    s.src = `https://www.googletagmanager.com/gtag/js?id=${ANALYTICS.gaId}`;
    document.head.appendChild(s);
    window.dataLayer = window.dataLayer || [];
    window.gtag = function () { window.dataLayer.push(arguments); };
    window.gtag("js", new Date());
    window.gtag("config", ANALYTICS.gaId);
  }
  if (ANALYTICS.gtmId && !document.getElementById("stj-gtm")) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ "gtm.start": new Date().getTime(), event: "gtm.js" });
    const s = document.createElement("script");
    s.id = "stj-gtm";
    s.async = true;
    s.src = `https://www.googletagmanager.com/gtm.js?id=${ANALYTICS.gtmId}`;
    document.head.appendChild(s);
  }
}

export function trackEvent(name, params = {}) {
  try {
    if (typeof window.gtag === "function") window.gtag("event", name, params);
    if (Array.isArray(window.dataLayer)) window.dataLayer.push({ event: name, ...params });
  } catch (_) { /* analytics must never break the app */ }
}
